module.exports = __webpack_public_path__ + "img/exithomepage.b2347b2d.png";